package components.selectColoursFromWatchListItem

import common.EColors
import common.ECssClasses
import components.Spacer.Spacer
import components.colourToneItem.EColourToneItemLeftButtonType
import core.AppContext
import core.enums.EImages
import core.extensions.toClassName
import core.extensions.toColor
import core.io.dto.MinifiedColourDTO
import core.ionic.IonButton
import core.localStorage.LocalStorageDAO
import core.util.ColourHelper
import csstype.AlignItems
import csstype.Auto
import csstype.BackgroundColor
import csstype.Display
import csstype.FlexDirection
import csstype.LineStyle
import csstype.NamedColor
import csstype.integer
import csstype.number
import csstype.pct
import csstype.px
import emotion.react.css
import module.watchlist.ColourListObject
import react.FC
import react.PropsWithClassName
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.router.Navigate
import react.useContext
import react.useState
import setUnsafeInnerHTML

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 30.11.22
 * Author : mariorosshirt
 */

external interface SelectColoursFromWatchListItemProps : PropsWithClassName {
    var mColourObject: ColourListObject
    var mColourToneItemLeftButtonType: EColourToneItemLeftButtonType?
    var mNavigate: String?
    var mDeleteFunction: () -> Unit
}

val SelectColoursFromWatchListItem = FC<SelectColoursFromWatchListItemProps> { props ->

    val mContext by useContext(AppContext)
    var (mLocalStorage, mLocalStorageDispatch) = mContext.mLocalStorageReducer
    val mColourObject = props.mColourObject

    val mIsColourBlack = ColourHelper.getContrastIsBlack(mColourObject.mColourCode)
    val mContrastColour = if (mIsColourBlack) NamedColor.black else NamedColor.white

    var navigate: String? by useState(props.mNavigate)

    fun onCardClick() {
        if (mLocalStorage.mFixedList.size < 5) {
            mContext.mLocalStorageReducer.component2().invoke(
                LocalStorageDAO.ELocalStorageAction.ADD_OR_DELETE_FROM_FIXEDLIST(
                    MinifiedColourDTO(
                        mColourObject.mUnique,
                        mColourObject.mName,
                        mColourObject.mArtNr,
                        mColourObject.mColourCode,
                        mColourObject.mColourCollection,
                        mColourObject.mAdditionalInfo1,
                        mColourObject.mAdditionalInfo2,
                        mColourObject.mEanCode)
                )
            )
        } else if (mLocalStorage.mFixedList.firstOrNull { it.mUnique == mColourObject.mUnique } != null) {
            mContext.mLocalStorageReducer.component2().invoke(
                LocalStorageDAO.ELocalStorageAction.DELETE_FROM_FIXEDLIST(
                    MinifiedColourDTO(
                        mColourObject.mUnique,
                        mColourObject.mName,
                        mColourObject.mArtNr,
                        mColourObject.mColourCode,
                        mColourObject.mColourCollection,
                        mColourObject.mAdditionalInfo1,
                        mColourObject.mAdditionalInfo2,
                        mColourObject.mEanCode
                    )
                )
            )
        } else {
            props.mDeleteFunction()
        }
    }

    div {
        css(ECssClasses.COLOUR_CARD_ITEM.toClassName(), props.className) {
            flexGrow = number(1.0)
            display = Display.flex
            flexDirection = FlexDirection.row
            backgroundColor = mColourObject.mColourCode.unsafeCast<BackgroundColor>()
            //height = 100.px
            borderRadius = 4.px
        }
        onClick = {
            onCardClick()
        }

        ReactHTML.div {
            css {
                display = Display.flex
                flexGrow = number(1.0)
                flexDirection = FlexDirection.column
            }
            ReactHTML.span {
                css(ECssClasses.PRODUCT_CARD_ITEM_SMALL_FONT.toClassName()) {
                    color = mContrastColour
                    zIndex = integer(2)
                    marginBottom = Auto.auto
                    flexGrow = number(1.0)
                    paddingLeft = 26.px
                    paddingTop = 15.px
                }
                +mColourObject.mColourCollection
            }
            ReactHTML.div {
                css {
                    paddingBottom = 15.px
                    paddingLeft = 26.px
                    paddingRight = 26.px
                }
                ReactHTML.span {
                    css {
                        color = mContrastColour
                    }
                    setUnsafeInnerHTML("<b>${mColourObject.mArtNr}</b><br>${mColourObject.mName}")
                }
            }
        }
        Spacer {}
        div {
            css {
                display = Display.flex
                alignItems = AlignItems.center
            }
            IonButton {
                css {
                    marginRight = 36.px
                    borderRadius = 50.pct
                    width = 43.px
                    height = 43.px
                    backgroundColor =
                        if (mLocalStorage.mFixedList.firstOrNull { it.mUnique == mColourObject.mUnique } == null) EColors.GRAY.toColor() else EColors.ORANGE.toColor()
                    borderWidth = 2.px
                    borderColor = NamedColor.white
                    borderStyle = LineStyle.solid
                }
                img {
                    css {
                        height = 24.px
                        maxWidth = 24.px
                    }
                    src = EImages.PAINT_ROLLER(EImages.EType.OUTLINED).mRelativePath
                }
                fill = "clear"
            }

        }
        navigate?.let {
            Navigate {
                to = it
            }
        }
    }

}